export default "__VITE_ASSET__BSoxGpdf__"